<template>
  <v-list-item-avatar :color="avatarColor" class="justify-center" v-bind="avatarOptions">
    {{ userInitials }}
  </v-list-item-avatar>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { types as usersTypes } from '../../store/users';
import { getColorForId } from '../../tools/UsersColors';

export default {
  name: 'ListItemAvatar',
  props: {
    userId: {
      type: String,
      required: false,
      default: undefined,
    },
    avatarOptions: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      getUserInitials: usersTypes.getters.userInitials,
    }),
    userInitials() {
      if (this.userId === undefined) {
        return '??';
      }
      const initials = this.getUserInitials(this.userId);
      if (initials.length === 0) {
        this.getUserProfile(this.userId);
      }
      return initials;
    },
    avatarColor() {
      if (this.userId === undefined) {
        return 'white';
      }

      return getColorForId(this.userId);
    },
  },
  methods: {
    ...mapActions({
      getUserProfile: usersTypes.actions.getUserProfile,
    }),
  },
};
</script>
